export default "__VITE_ASSET__B1Fj3zIF__"